import React from 'react'
import { Box } from '@mui/material'
import ContentWrapper from '../components/ContentWrapper'
import Txt from '../components/Txt'
import RestaurantView from './RestaurantView'
import { useCurrentUser } from '../utils/user'
import { useView } from '../utils/viewContext'

// Bevorzugtes Restaurant beim Öffnen des Dashboards; steht es nicht zur Auswahl, gilt die
// kleinste ID.
const DEFAULT_RESTAURANT_ID = '107'

const RestaurantsView = (): JSX.Element => {
	const { data: currentUser } = useCurrentUser()
	const { selectedRestaurantId, setSelectedRestaurantId } = useView()

	const adminRestaurants = currentUser?.adminRestaurants

	const activeRestaurantId = React.useMemo(() => {
		if (!adminRestaurants?.length) return null
		if (adminRestaurants.some((restaurant) => restaurant.id === selectedRestaurantId)) {
			return selectedRestaurantId
		}
		if (adminRestaurants.some((restaurant) => restaurant.id === DEFAULT_RESTAURANT_ID)) {
			return DEFAULT_RESTAURANT_ID
		}
		return adminRestaurants.reduce((lowest, restaurant) =>
			Number(restaurant.id) < Number(lowest.id) ? restaurant : lowest
		).id
	}, [adminRestaurants, selectedRestaurantId])

	// Die Auswahl steht erst mit den geladenen Restaurants fest — und wieder neu, sobald das
	// gemerkte Restaurant nicht mehr in der Liste steht.
	React.useEffect(() => {
		if (activeRestaurantId && activeRestaurantId !== selectedRestaurantId) {
			setSelectedRestaurantId(activeRestaurantId)
		}
	}, [activeRestaurantId, selectedRestaurantId, setSelectedRestaurantId])

	const handleChangeRestaurant = React.useCallback(
		(value: string | null) => {
			if (value) setSelectedRestaurantId(value)
		},
		[setSelectedRestaurantId]
	)

	const restaurantItems = React.useMemo(
		() =>
			adminRestaurants?.map((restaurant) => ({
				label: restaurant.title,
				value: restaurant.id,
			})) ?? [],
		[adminRestaurants]
	)

	return (
		<ContentWrapper p="1rem" center>
			{!adminRestaurants?.length ? (
				<Txt variant="body2">Keine Restaurants vorhanden.</Txt>
			) : (
				<Box width="100%">
					<RestaurantView
						restaurantItems={restaurantItems}
						activeRestaurantId={activeRestaurantId}
						onChangeRestaurant={handleChangeRestaurant}
					/>
				</Box>
			)}
		</ContentWrapper>
	)
}

export default RestaurantsView
